/**
 * Possible form states:
 * - NOT_MODIFIED: Form has not been modified
 * - NOT_SAVED: Form has not been saved yet
 * - CREATED: Form was successfully created
 * - MODIFIED: Form has been modified and not saved
 */
export const formStates = ['NOT_MODIFIED', 'NOT_SAVED', 'CREATED', 'MODIFIED'] as const;
/**
 * @see {@link formStates} for possible form states
 */
export type FormState = (typeof formStates)[number];
